export default "__VITE_ASSET__DTyzzoly__"